<div class="user-dashboard-container">
  <div class="dashboard-content">
    @if (loadMetabase()) {
      <app-metabase-dashboard class="metabase-dashboard" componentSelector="app-user-dashboard"></app-metabase-dashboard>
    }
  </div>
</div>
